export default __webpack_public_path__ + "static/PopupBackground1-4022ff3d4da21b3cfec98fa01ae981e1.webp";